// One-line descriptions of the event behind an XP award, for the "where did this come from" list.
export function describeEvent(type: string, payload: Record<string, unknown>): string {
  const n = (k: string) => Number(payload[k] ?? 0);
  switch (type) {
    case "set.completed":
      return `${payload.exercise ?? payload.exercise_id ?? "Set"} ${n("weight_kg")} kg × ${n("reps")}`;
    case "session.completed":
      return String(payload.title ?? "Session");
    case "swim.completed":
      return `Swam ${n("distance_m")} m`;
    case "boxing.completed":
      return `Boxing (${payload.kind ?? "session"}) ${Math.round(n("duration_s") / 60)} min`;
    case "conditioning.completed":
      return `${String(payload.kind ?? "conditioning").replace("_", " ")} ${Math.round(n("duration_s") / 60)} min`;
    case "mobility.completed":
      return `Mobility ${Math.round(n("duration_s") / 60)} min`;
    case "sleep.recorded":
      return `Sleep ${(n("duration_s") / 3600).toFixed(1)} h${payload.efficiency ? `, ${payload.efficiency}% efficient` : ""}`;
    case "readiness.recorded":
      return `Readiness ${n("score")}`;
    case "bodycomp.recorded":
      return `Weigh-in ${n("weight_kg")} kg`;
    case "bedtime.declared":
      return `Bedtime declared for ${String(payload.target_local ?? "")}`;
    case "quest.completed":
      return `Quest: ${payload.name ?? payload.quest_id}${payload.bonus_multiplier ? ` (×${payload.bonus_multiplier})` : ""}`;
    default:
      return type;
  }
}
